import React from "react";
import classes from "./ButtonGroup.module.css";
import { Button } from "../Button/Button";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";

export const ButtonGroup = ({
  btnIcon1,
  btnIcon2,
  onClick1,
  onClick2,
  customStyle,
}) => {
  return (
    <>
      <div
        className={[classes.btnGroup].join(" ")}
        style={{
          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          ...customStyle,
        }}
      >
        <Button
          className={classes.btn1}
          icon={btnIcon1}
          label=""
          size={"small"}
          iconClass={[classes.iconSize].join(" ")}
          onClick={onClick1}
        />
        <Button
          className={classes.btn2}
          size={"small"}
          icon={btnIcon2}
          label=""
          iconClass={[classes.iconSize].join(" ")}
          onClick={onClick2}
        />
      </div>
    </>
  );
};
